import { IPlace, ITag, Iterable, Prettify } from "types";

type Response = { tag: string; places: Iterable<IPlace>[] }[];
export const groupPlacesByTags = (
  places: Iterable<IPlace>[],
  tags: ITag[]
): Prettify<Response> => {
  const response: Response = [];
  for (const { name } of tags) {
    const selectedPlaces: Iterable<IPlace>[] = [];

    places.forEach((place) => {
      if (place.tags.includes(name)) {
        selectedPlaces.push(place);
      }
    });

    response.push({ tag: name, places: selectedPlaces });
  }

  return response;
};
